// -----------------------------
// CONFIG
// -----------------------------
const { discount_type, display_percent } = window.saveLPData;
const DISCOUNT_MAP_67 = { 1: 33, 2: 47, 3: 60, 4: 67, 6: 67 };
const DISCOUNT_MAP_56 = { 1: 20, 2: 37, 3: 0, 4: 56 };

const STICK_BASE_PRICE = 19.95

const MAX_GIFTS = 4;
const OUT_OF_STOCK_QTY = [3]; // can expand

function validateLiquidData() {
  if (!window.saveLPData) {
    console.warn('Error: window.saveLPData is not defined.');
    return false;
  }

  if (typeof discount_type !== 'string' || discount_type.trim() === '') {
    console.warn('Error: discount_type is missing or invalid.');
    return false;
  }

  return true;
}


class SaveLPTracking {
  /** Must match STORAGE_KEY / STORAGE_VALUE in assets/save-lp-ten-reasons-meta-shift.js (landing only). */
  static TEN_REASONS_META_STORAGE_KEY = 'carpe_ten_reasons_meta_shift_v1';
  static TEN_REASONS_META_STORAGE_VALUE = '1';

  static isTenReasonsMetaShiftCohort() {
    try {
      return (
        sessionStorage.getItem(SaveLPTracking.TEN_REASONS_META_STORAGE_KEY) ===
        SaveLPTracking.TEN_REASONS_META_STORAGE_VALUE
      );
    } catch (e) {
      return false;
    }
  }

  static safeTrackFBViewContent(retries = 10) {
    if (typeof fbq === 'function') {
      fbq('track', 'ViewContent', { content_ids: ['39731826098309'], content_name: 'Underarm Stick - Fresh Powder', content_type: 'product', currency: 'USD', value: 19.95 });
    } else if (retries > 0) {
      setTimeout(() => SaveLPTracking.safeTrackFBViewContent(retries - 1), 100);
    } else {
      console.warn('fbq not found after multiple retries');
    }
  }

  /** Same bare payload / retry budget as TrackingService.sendFbAddToCart on step 2 */
  static safeTrackFBAddToCart(retries = 50) {
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart');
    } else if (retries > 0) {
      setTimeout(() => SaveLPTracking.safeTrackFBAddToCart(retries - 1), 100);
    } else {
      console.warn('fbq not found after multiple retries (AddToCart)');
    }
  }

  static safeTrackGtagViewContent(retries = 10) {
    if (typeof gtag === 'function') {
      gtag('event', 'save56_view_quantity_selector');
    } else if (retries > 0) {
      setTimeout(() => SaveLPTracking.safeTrackGtagViewContent(retries - 1), 100);
    } else {
      console.warn('gtag not found after multiple retries');
    }
  }


  static safeTrackOpenAIViewContent(retries = 10) {
    if (typeof oaiq === 'function') {
      oaiq("measure", "page_viewed", {
        type: "contents"
      });
    } else if (retries > 0) {
      setTimeout(() => SaveLPTracking.safeTrackOpenAIViewContent(retries - 1), 100);
    } else {
      console.warn('oaiq not found after multiple retries');
    }
  }
}

class QuantitySelectorComponent {
  constructor() {
    this.container = document.querySelector("main.save-lp-page-container");
    if (!this.container) return console.warn('[QuantitySelectorComponent] Container not found');

    this.giftCardContainers = Array.from(this.container.querySelectorAll('[data-gift-container]'));
    this.ctaButtons = Array.from(this.container.querySelectorAll('[data-cta-container]'));
    this.discountAmounts = Array.from(this.container.querySelectorAll('[data-discount-amount]'));
    this.quantityButtons = Array.from(this.container.querySelectorAll('[data-qty]'));
    this.giftCountNumericContainers = Array.from(this.container.querySelectorAll('[data-gift-count-numeric]'))
    this.totalCartPrices = Array.from(this.container.querySelectorAll('[data-cart-price-total]'));
    this.discountedCartPrices = Array.from(this.container.querySelectorAll('[data-cart-price-discount]'));
    this.renewalPrices = Array.from(this.container.querySelectorAll('[data-renewal-price]'));

    if (!this.giftCardContainers.length || !this.ctaButtons.length || !this.discountAmounts.length) {
      console.warn('[QuantitySelectorComponent] Some DOM elements missing');
    }

    this.quantityButtons.forEach(btn => btn.addEventListener('click', e => this.handleClick(e)));
  }

  handleClick(event) {
    const button = event.target.closest('[data-qty]');
    if (!button) return;

    const qty = parseInt(button.dataset.qty);
    if (!qty || OUT_OF_STOCK_QTY.includes(qty)) {
      console.log(`[QuantitySelectorComponent] qty=${qty} is out of stock`);
      return;
    }

    if (button.classList.contains('is-active')) return;

    this.updateState(qty);
  }

  updateState(qty) {
    this.updateActiveQuantitySelector(qty);
    this.updateActiveGifts(qty);
    this.updateCtaLinks(qty);
    this.updateDiscountAmount(qty);
    this.updateCartPrices(qty);
    this.updateGiftCountNumericContainers(qty)
    this.updateRenewalPrices(qty);
  }

  updateRenewalPrices(qty) {
    this.renewalPrices.forEach(el => {
      const unitPriceCents = parseInt(el.dataset.unitPriceCents, 10);
      if (unitPriceCents) el.textContent = (unitPriceCents * qty / 100).toFixed(2);
    });
  }

  updateActiveQuantitySelector(qty) {
    this.quantityButtons.forEach(btn => btn.classList.toggle('is-active', parseInt(btn.dataset.qty) === qty));
  }

  updateActiveGifts(qty) {
    this.giftCardContainers.forEach(container => {
      const gifts = Array.from(container.querySelectorAll('[data-gift]'));
      if (gifts.length !== MAX_GIFTS) return console.warn('Gift count mismatch');
      gifts.forEach((gift, i) => gift.classList.toggle('is-active', i < qty));
    });
  }

  updateCtaLinks(qty) {
    this.ctaButtons.forEach(btn => {
      const href = btn.getAttribute('href');
      // If sticks param exists, replace it; otherwise, append it
      if (href.includes('sticks=')) {
        btn.href = href.replace(/(sticks=)\d+/, `$1${qty}`);
      } else {
        const separator = href.includes('?') ? '&' : '?';
        btn.href = `${href}${separator}sticks=${qty}`;
      }
    });
  }

  sumUniqueActiveGiftPrices() {
    // get all active gifts & deduplicate in case of multiple gift sections on page 
    const elements = document.querySelectorAll('.is-active[data-gift]');
    const seen = new Set();
    let total = 0;

    elements.forEach(el => {
      const gift = el.getAttribute('data-gift');
      if (!seen.has(gift)) {
        seen.add(gift);
        const price = parseFloat(el.getAttribute('data-gift-price')) || 0;
        total += price;
      }
    });

    return total;
  }


  updateCartPrices(qty) {
    const totalGiftValue = this.sumUniqueActiveGiftPrices();
    const totalStickPrice = STICK_BASE_PRICE * qty
    const total = totalGiftValue + totalStickPrice

    const selectedStick = document.querySelector(`[data-qty="${qty}"]`)
    if (!selectedStick) {
      console.warn(`[updateCartPrices] can not find div with [data-qty="${qty}"]`)
      return;
    }
    const selectedStickPrice = selectedStick.dataset.stickPrice;
    const discount = selectedStickPrice * qty;

    this.totalCartPrices.forEach(el => el.textContent = `${total ? total.toFixed(2) : '0'}`);
    this.discountedCartPrices.forEach(el => el.textContent = `${discount ? discount.toFixed(2) : '0'}`);
  }

  updateDiscountAmount(qty) {
    let percent = '';

    if (discount_type == '56') {
      percent = DISCOUNT_MAP_56[qty] ?? '';
    } else if (discount_type == '67') {
      percent = DISCOUNT_MAP_67[qty] ?? '';
    }
    // 4 sticks is the headline "save up to" percent
    if (qty === 4 && display_percent) percent = display_percent;
    this.discountAmounts.forEach(el => el.textContent = percent);
  }

  updateGiftCountNumericContainers(qty) {
    if (!qty) return;
    if (this.giftCountNumericContainers.length === 0) return;
    this.giftCountNumericContainers.forEach(el => el.textContent = qty);
  }
}



class StickyCtaComponent {
  constructor({
    elementId,
    activeClass,
    scrollThreshold = 1200
  } = {}) {
    this.activeClass = activeClass;
    this.scrollThreshold = scrollThreshold;

    this.stickyCta = document.getElementById(elementId);

    if (!this.stickyCta) {
      console.warn('[StickyCtaComponent] Sticky CTA element not found');
      return;
    }

    this.init();
  }

  init() {
    window.addEventListener('scroll', () => {
      if (window.scrollY >= this.scrollThreshold) {
        this.stickyCta.classList.add(this.activeClass);
      } else {
        this.stickyCta.classList.remove(this.activeClass);
      }
    });
  }
}


class VideoListController {
  constructor({ elementId } = {}) {
    this.root = document.getElementById(elementId);
    this.items = [];
    this.activeIndex = null;

    if (!this.root) {
      console.warn('[VideoListController] List element not found');
      return;
    }

    this.init();
  }

  init() {
    const nodes = this.root.querySelectorAll('[data-video-item]');
    if (!nodes.length) return;

    this.items = Array.from(nodes).map((item, index) => ({
      index,
      el: item,
      thumb: item.querySelector('[data-video-thumb]'),
      video: item.querySelector('[data-video]')
    }));

    this.bind();
  }

  bind() {
    this.items.forEach((item) => {
      if (!item.thumb || !item.video) return;

      item.thumb.addEventListener('click', () => {
        this.transitionTo(item.index);
      });

      item.video.addEventListener('click', () => {
        if (item.video.paused) {
          item.video.play();
        } else {
          item.video.pause();
        }
      });
    });
  }

  transitionTo(nextIndex) {
    if (this.activeIndex === nextIndex) return;

    if (this.activeIndex !== null) {
      this.stop(this.items[this.activeIndex]);
    }

    this.play(this.items[nextIndex]);
    this.activeIndex = nextIndex;
  }

  play(item) {
    const self = this;
    item.el.setAttribute('data-video-state', 'loading');

    if (!item.video.src && item.video.dataset.src) {
      item.video.src = item.video.dataset.src;
    }

    const clearLoadingTimeout = () => {
      if (item._loadingTimeout) {
        clearTimeout(item._loadingTimeout);
        item._loadingTimeout = null;
      }
    };

    item.video.addEventListener('playing', () => {
      clearLoadingTimeout();
      item.el.setAttribute(
        'data-video-state',
        self.activeIndex === item.index ? 'playing' : 'idle'
      );
    }, { once: true });

    item.video.addEventListener('error', () => {
      clearLoadingTimeout();
      item.el.setAttribute('data-video-state', 'idle');
    }, { once: true });

    item._loadingTimeout = setTimeout(() => {
      item._loadingTimeout = null;
      if (item.el.getAttribute('data-video-state') === 'loading') {
        item.el.setAttribute('data-video-state', 'idle');
      }
    }, 15000);

    const playPromise = item.video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => {
        clearLoadingTimeout();
        item.el.setAttribute('data-video-state', 'idle');
      });
    }
  }

  stop(item) {
    if (item._loadingTimeout) {
      clearTimeout(item._loadingTimeout);
      item._loadingTimeout = null;
    }
    item.video.pause();
    item.video.currentTime = 0;
    item.el.setAttribute('data-video-state', 'idle');
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const isLiquidDataValid = validateLiquidData();
  if (!isLiquidDataValid) {
    console.error('Validation of liquid data failed. Check console for details.');
  }

  new QuantitySelectorComponent();

  new StickyCtaComponent({
    elementId: 'bottom-sticky-atc-cta-control',
    activeClass: 'is-sticky'
  });

  new VideoListController({ elementId: 'save-lp-step1-videos__list' });

  if (SaveLPTracking.isTenReasonsMetaShiftCohort()) {
    SaveLPTracking.safeTrackFBAddToCart();
  } else {
    SaveLPTracking.safeTrackFBViewContent();
  }
  SaveLPTracking.safeTrackOpenAIViewContent();
  SaveLPTracking.safeTrackGtagViewContent();
});
